
export { checkbox } from "/vercel/path0/styled-system/recipes/checkbox.mjs"